import { render, staticRenderFns } from "./ErpIntegration.vue?vue&type=template&id=112beef5&scoped=true"
import script from "./ErpIntegration.vue?vue&type=script&lang=js"
export * from "./ErpIntegration.vue?vue&type=script&lang=js"
import style0 from "./ErpIntegration.vue?vue&type=style&index=0&id=112beef5&prod&lang=css"
import style1 from "./ErpIntegration.vue?vue&type=style&index=1&id=112beef5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112beef5",
  null
  
)

export default component.exports